<template>
    <DisplayBattery
        :value="value"
        :title="formatDateDefault(row?.LastBatteryUpdate ?? null, 'DATETIMESHORT')"
        v-if="isActive && value != null"
    />
</template>
<script setup lang="ts">
import { DisplayBattery } from '@/components';
import type { TrackingDeviceWithRaceContestantPosition } from '@/objects/generated';
import { formatDateDefault } from '@/utilities/dateutils';
import { computed } from 'vue';

/**
 * This wrap the battery display so we can hide it on null
 */

const props = defineProps<{
    /**
     * The battery level in percent
     */
    value: number | null;

    /**
     * The entire datarow
     */
    row?: TrackingDeviceWithRaceContestantPosition | null;
}>();

// We need to check if the last battery update is more than 1 hour ago then we dont show anything
const isActive = computed(() => {
    if (props.value == null) {
        return false;
    }

    const lastUpdate = props.row?.LastBatteryUpdate;
    if (!lastUpdate) {
        return false;
    }

    const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
    if (lastUpdate < oneHourAgo) {
        return false;
    }

    return true;
});
</script>
